<div class="container">
    <section class="about-area pt-5" >
        <div class="container-fluid">
            <div class="row align-items-center"> 
                <div class="overview-box">
                    
    
                    <div class="overview-content">
                        <div class="content right-content">
                            
                            
                           
                            <h2 *ngIf="title">{{title}}</h2>
                            <p *ngIf="subtitle" [innerHTML]="subtitle"></p>



                            <ul class="features-list">
                                <li *ngIf="box1"><span><i class='bx bx-check'></i>{{box1}}</span></li>
                                <li *ngIf="box2"><span><i class='bx bx-check'></i> {{box2}}</span></li>
                                <li *ngIf="box3"><span><i class='bx bx-check'></i> {{box3}}</span></li>
                                <li *ngIf="box4"><span><i class='bx bx-check'></i> {{box4}}</span></li>
                                <li *ngIf="box5"><span><i class='bx bx-check'></i> {{box5}}</span></li>
                                <li *ngIf="box6"><span><i class='bx bx-check'></i> {{box6}}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>